import React from 'react';
import { FormattedMessage } from 'react-intl';
import { takeEvery, put, call } from 'redux-saga/effects';
import { pushToast } from 'containers/ToastManager/actions';
import catchErrors from 'utils/commands/catchErrors';
import workspaceService from 'services/WorkspaceService';
import { push } from 'connected-react-router';

import messages from '../messages';
import * as constants from '../constants';

export function* sendRequest(connection, action) {
  const workspaceProjectCreate = yield call(connection.fetch.bind(connection), {
    type: constants.RTM_WORKSPACE_PROJECT_CREATE,
    workspaceId: workspaceService.getSelectedWorkspaceId(),
    name: action.project.name,
  });
  if (workspaceProjectCreate.type === constants.RTM_WORKSPACE_PROJECT_CREATE_OK) {
    const project = workspaceProjectCreate.response.project;
    yield put(push(`/courseware/${project.id}`));
  } else {
    if(workspaceProjectCreate.message != null) {
      messages.failedWorkspaceProjectCreate.defaultMessage = workspaceProjectCreate.message;
    }
    yield put(pushToast({
      type: 'simple',
      message: <FormattedMessage {...messages.failedWorkspaceProjectCreate} />,
    }));
  }
}

export default function* (connection) {
  yield takeEvery(constants.COMMAND_WORKSPACE_PROJECT_CREATE, catchErrors, sendRequest, connection);
}
